import { Typography, useTheme } from '@mui/material';

import { ATSConnectHiringRequestCandidateFeedbackTestIds } from 'data-testids/ATS';
import { LowerVisibilityText, VisibilityRow, TemplateNameContainer } from '../../../styles/styles';
import { TemplateAndVisibilityProps } from '../../../types/feedbackDetailTypes';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export const TemplateAndVisibility: React.FC<TemplateAndVisibilityProps> = ({
  templateName,
  isDraft,
}) => {
  const theme = useTheme();

  return (
    <VisibilityRow
      data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.TEMPLATE_AND_VISIBILITY}
    >
      <TemplateNameContainer>
        <InsertDriveFileOutlinedIcon />
        <Typography
          data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.TEMPLATE_NAME}
          sx={{ paddingLeft: theme.spacing(0.5) }}
        >
          {templateName}
        </Typography>
      </TemplateNameContainer>
      {isDraft && <DraftVisibilityDisplay />}
    </VisibilityRow>
  );
};

const DraftVisibilityDisplay: React.FC = () => {
  const theme = useTheme();

  return (
    <LowerVisibilityText data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.VISIBILITY}>
      &nbsp;
      <VisibilityOffIcon
        data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.VISIBILITY_ME_ONLY}
      />
      <Typography sx={{ paddingLeft: theme.spacing(0.5) }}>Visible only to you</Typography>
    </LowerVisibilityText>
  );
};
